import React, {Component} from 'react';
import './SearchFilterPane.css';
import {connect} from 'react-redux';
import actions from './search.actions';
import {
	getCategoryCommunitiesFromResults,
	getCommunityFilterMap,
	getFilteredSuburb,
	getRelevantSuburbs,
	getRelevantCommunitySuburbs
} from './search.selectors';
import {Dropdown} from '../widgets';
import SearchUserTypeSelector from './SearchUserTypeSelector';

const getTypePlural = searchFor => {
	switch (searchFor) {
		case 'provider': // fall-through
		default:
			return 'providers';
		case 'community':
			return 'communities';
		case 'user':
			return 'users';
	}
};

export class SearchFilterPane extends Component {
	constructor() {
		super();
		this.state = {
			expanded: false // Expanded state only applies to mobile.
		};

		this.toggleExpanded = () => this.setState({expanded: !this.state.expanded});
		this.setSearchProvider = () => this.props.setSearchFor('provider');
		this.setSearchCommunity = () => this.props.setSearchFor('community');
		this.setSearchUser = () => this.props.setSearchFor('user');
	}

	render() {
		const props = this.props;

		const {toggleCommunityFilter, searchFilterSuburb, searchFor = 'provider'} = props;

		const searchForPlural = getTypePlural(searchFor);

		const categories = searchFor === 'community' ? [] : getCategoryCommunitiesFromResults(props);
		const communityFilterMap = searchFor === 'community' ? [] : getCommunityFilterMap(props) || {};
		const filteredSuburb = getFilteredSuburb(props);
		const suburbs =
			searchFor === 'community' ? getRelevantCommunitySuburbs(props) : getRelevantSuburbs(props);

		return (
			<div className={`SearchFilterPane ${this.state.expanded ? 'expanded' : ''}`}>
				<button className="SearchFilterPane-toggle" onClick={this.toggleExpanded}>
					<span className="icon icon-filter_list" />
				</button>
				{!props.isMobile && (
					<SearchUserTypeSelector
						compact={true}
						setSearchProvider={this.setSearchProvider}
						setSearchCommunity={this.setSearchCommunity}
						setSearchUser={this.setSearchUser}
						searchFor={searchFor}
						radii={false}
					/>
				)}

				{/* check if there are no available filters and display message for user */}
				{(!suburbs || (suburbs && !suburbs.length)) && Object.keys(categories).length === 0 ? (
					<section>
						<p>No Categories or Communities to filter</p>
					</section>
				) : (
					undefined
				)}

				{suburbs && suburbs.length ? (
					<section className="SearchFilterPane-location">
						<h3>
							<span>Location</span>
							<button>
								<span className="SearchFilterPane-icon-unfold_less" />
							</button>
						</h3>
						<div className="SearchFilterPane-content">
							<p>Find {searchForPlural} around</p>
							<div className="SearchFilterPane-geo">
								<div className="SearchFilterPane-dropdown">
									<span className="icon icon icon-room" />
									<Dropdown
										items={
											suburbs &&
											suburbs.map(({suburbUuid, suburb, postcode}) => ({
												value: suburbUuid,
												label: suburb,
												extra: postcode
											}))
										}
										allowNull={true}
										onSelect={searchFilterSuburb}
										value={filteredSuburb && filteredSuburb.suburb}
									/>
								</div>
							</div>
						</div>
					</section>
				) : (
					undefined
				)}

				{categories &&
					Object.keys(categories).map(
						categoryName =>
							categories[categoryName] && (
								<section key={categoryName}>
									<h3>
										<span>{categoryName}</span>
										<button>
											<span className="icon icon-unfold_less" />
										</button>
									</h3>
									<div className="SearchFilterPane-content">
										<p>Find {searchForPlural} connected to</p>
										<ol>
											{categories[categoryName] &&
												categories[categoryName].map(community => (
													<li
														key={community.uuid}
														onClick={() => {
															toggleCommunityFilter(
																community.uuid,
																!communityFilterMap[community.uuid]
															);
															this.toggleExpanded();
															window.scroll(0, 0);
														}}>
														<span
															className={`SearchFilterPane-checkbox ${
																communityFilterMap[community.uuid]
																	? 'icon-check_box'
																	: 'icon-check_box_outline_blank'
															}`}
														/>
														<span>{community.name}</span>
														<span className="SearchFilterPane-count">{community.count}</span>
													</li>
												))}
											{/*<li className="SearchFilterPane-more"><a href="#">More…</a></li>*/}
										</ol>
									</div>
								</section>
							)
					)}
			</div>
		);
	}
}

export default connect(
	({ui, search, location}) => ({
		results: search && search.results,
		searchFor: search && search.searchFor,
		communityFilters: search && search.filters && search.filters.communities,
		suburbFilter: search && search.filters && search.filters.suburb,
		suburbs: location && location.suburbs,
		isMobile: ui.screenSize === 'mobile'
	}),
	dispatch => ({
		searchFilterSuburb: value => dispatch(actions.searchFilterSuburb(value)),
		toggleCommunityFilter: (uuid, value) =>
			dispatch(actions.searchToggleCommunityFilter({uuid, value})),
		setSearchFor: searchFor => {
			dispatch(actions.searchFor(searchFor));
			dispatch(actions.performSearch());
		}
	})
)(SearchFilterPane);



// WEBPACK FOOTER //
// ./src/search/SearchFilterPane.js